import { EventTarget } from 'event-target-shim';

class AuthenticationTarget extends EventTarget {
  constructor() {
    super();
    this.ids = [];
  }

  on(type, callback, options) {
    this.addEventListener(type, callback, options);
  }

  unique(type, id, callback, options) {
    if (!this.ids.includes(id)) {
      this.addEventListener(type, callback, options);
      this.ids.push(id);
    }
  }


  dispatch(type, ...data) {
    this.dispatchEvent({ ...data, type });
  }
}

const authTarget = new AuthenticationTarget();

export default authTarget;
